import { isBrowser } from '@croquiscom/web2app';

import { getSiteIdFromHost, SiteId } from '@common/site-manager';

export const isPosty = () => {
  if (isBrowser()) {
    const app_window = window as any;
    const HAS_POSTY_PROPS = !!(app_window?.posty || app_window?.webkit?.messageHandlers?.posty);
    return HAS_POSTY_PROPS || (/(posty)/i.test(navigator.userAgent) && !navigator.userAgent.includes('Posty/1.0'));
  } else {
    return false;
  }
};

export const isPostyWeb = () => {
  return !isPosty() && getSiteIdFromHost() === SiteId.POSTY;
};
